import React from 'react';
import Helmet from 'react-helmet';
import compose from 'lodash/fp/compose';
import { withSeo } from '@catalogo/core-connect/seo';
import { withConfig } from '@catalogo/core-connect/config';
import { SeoProps } from './types';
import { LinkTags } from './tags/link-tags';
import { AppLinks } from './tags/app-links';
import { MetaTags } from './tags/meta-tags';
import { NoIndex } from './tags/no-index';
import { PreloadedImages } from './tags/preload-images';
import { SocialTags } from './tags/social-tags';
import { Preconnect } from './tags/preconnect';

export const Seo: React.FC<SeoProps> = ({ seo, config, history }) => (
  <Helmet encodeSpecialCharacters={false}>
    <title>{seo.title || config.title}</title>
    {NoIndex({ seo })}
    {PreloadedImages()}
    {MetaTags({ config, seo })}
    {Preconnect({ config })}
    {AppLinks({ seo, config, history })}
    {SocialTags({ config })}
    {LinkTags({ seo, config })}
  </Helmet>
);

export default compose(withSeo, withConfig)(Seo);
